var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc20Dollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M6 7.5c0-1.667 1.298-3.01 3.007-3.391l-.005-.054L9 3a1 1 0 0 1 2 0v1l-.007.109C12.703 4.49 14 5.833 14 7.5a1 1 0 0 1-1.993.117L12 7.5c0-.784-.86-1.5-2-1.5-1.14 0-2 .716-2 1.5 0 .745.775 1.428 1.831 1.495L10 9c2.173 0 4 1.523 4 3.5 0 1.664-1.294 3.006-3 3.39V17a1 1 0 1 1-2 0v-1.11c-1.705-.383-3-1.725-3-3.39a1 1 0 0 1 1.993-.117L8 12.5c0 .784.86 1.5 2 1.5 1.14 0 2-.716 2-1.5 0-.745-.775-1.428-1.831-1.495L10 11c-2.173 0-4-1.523-4-3.5Z",
  clipRule: "evenodd"
})));
export default SvgIc20Dollar;